import { render, staticRenderFns } from "./challenge.vue?vue&type=template&id=91ca85b2&scoped=true&lang=html&"
import script from "./challenge.vue?vue&type=script&lang=js&"
export * from "./challenge.vue?vue&type=script&lang=js&"
import style0 from "./challenge.vue?vue&type=style&index=0&id=91ca85b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ca85b2",
  null
  
)

export default component.exports